import { withTexts } from '../with-texts';
import { 
  SelectSingle as UISelectSingle, 
  SelectSingleHierarchy as UISelectSingleHiearchy,
  SelectMultiple as UISelectMultiple,
  SelectMultipleHierarchy as UISelectMultipleHierarchy
} from 'ui';

const selectTexts = {
  textOptionsDone: 7338,
  textOptionsNotFound: 7644,
  textOptionsLoadError: 7524,
  textSearchRequired: 8146,
  textSearchRequiredExceedsMaxResult: 8625,
  textPageOf: 8454,
  textSelectAll: 8420,
  textClearAll: 8421
};

export const SelectSingle = withTexts(selectTexts)(UISelectSingle);
export const SelectSingleHierarchy = withTexts(selectTexts)(UISelectSingleHiearchy);
export const SelectMultiple = withTexts(selectTexts)(UISelectMultiple);
export const SelectMultipleHierarchy = withTexts(selectTexts)(UISelectMultipleHierarchy);
